import { Component, ChangeDetectionStrategy } from '@angular/core';
import { PagedObjectManagerComponent } from '../../../core/component/paged-object-manager/paged-object-manager';
import { ColumnVisibility } from '../../../core/model/column-definition';
import { FilterDefinitionItem } from '../../../core/model/filter-definition-item';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { ColumnDefinitionFactory } from '../../../core/service/factory/column-definition-factory.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { CompanyService } from '../../../rent/service/data/company.service';
import { CompanyMortgage } from '../../model/company-mortgage';
import { AddAmortizationCommandHandler } from '../../service/command/add-amortization-command-handler.service';
import { CompanyMortgageCommandHandlerResolver } from '../../service/command/company-mortgage-command-handler-resolver.service';
import { CompanyMortgageService } from '../../service/company-mortgage.service';
import { CreditInstituteService } from '../../service/credit-institute.service';

@Component({
    selector: 'app-company-mortgage-manager',
    templateUrl: './../../../core/component/paged-object-manager/paged-object-manager.html',
    styleUrls: ['./../../../core/component/paged-object-manager/paged-object-manager.scss'],
    providers: [CompanyMortgageCommandHandlerResolver, CompanyMortgageService, AddAmortizationCommandHandler],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CompanyMortgageManagerComponent extends PagedObjectManagerComponent<CompanyMortgage> {
  constructor(
    columnFactory: ColumnDefinitionFactory,
    dispatcher: CommandDispatcher,
    handlerResolver: CompanyMortgageCommandHandlerResolver,
    messageService: MessageService,
    navigationService: NavigationService,
    private readonly _companyService: CompanyService,
    private readonly _creditInstituteService: CreditInstituteService,
    private readonly _service: CompanyMortgageService
  ) {
    super(_service, messageService, navigationService, dispatcher, handlerResolver);

    this.columnDefinition = [
      columnFactory.create('COMMON.COMPANY', 'companyName'),
      columnFactory.create('MORTGAGE.CREDIT_INSTITUTE', 'creditInstituteName'),
      columnFactory.create('MORTGAGE.COMPANY_MORTGAGE_NAME', 'name'),
      columnFactory.createMoney('MORTGAGE.INITIAL_AMOUNT', 'initialAmount'),
      columnFactory.createMoney('MORTGAGE.BALANCE', 'balance'),
      columnFactory.createNumber('MORTGAGE.CURRENT_INTEREST_RATE', 'currentInterestRate', ColumnVisibility.optional),
      columnFactory.createDate('MORTGAGE.NEXT_INTEREST_CHANGE_DATE', 'nextInterestRateChangeDate', ColumnVisibility.optional),
    ];

    this.title = 'MORTGAGE.COMPANY_MORTGAGE';
    this.preferencesKey = 'mortgage.company-mortgage.list';
  }

  ngOnInit() {
    super.ngOnInit();
    this.AddSubscription(
      this._service.getFilterDefinition().subscribe(definition => {
        this.filterDefinition = [
          new FilterDefinitionItem(
            'MORTGAGE.COMPANY_MORTGAGE_NAME',
            'name',
            definition.filter.name,
            null,
            definition.filter.selectedFields.includes('name')
          ),
          new FilterDefinitionItem(
            'COMMON.COMPANY',
            'companyId',
            definition.filter.companyId,
            this._companyService,
            definition.filter.selectedFields.includes('companyId')
          ),
          new FilterDefinitionItem(
            'MORTGAGE.CREDIT_INSTITUTE',
            'creditInstituteId',
            definition.filter.creditInstituteId,
            this._creditInstituteService,
            definition.filter.selectedFields.includes('creditInstituteId')
          ),
        ];
      })
    );
  }
}
